import { useState } from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ApprovalGroupMemberships } from 'modules/approvals/store/collections/approvalGroupMembership'
import { Categories as Category } from 'modules/approvals/store/models/ApprovalGroupMembership'

interface Props {
  category: Category
}

/**
 * This hook can be used to tell if the current access is member
 * of an auto-approval group of a given category
 */
const useIsAccessInAutoApprovalGroup = ({ category }: Props) => {
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const [isAutoApprover, setIsAutoApprover] = useState<boolean | undefined>()
  const collection = new ApprovalGroupMemberships()

  const { loading } = useAsyncData(async () => {
    await collection.fetch({ data: { category: category, auto_approval_group: true } })
    setIsAutoApprover(collection.some({ access_id: accessId }))
  }, [category])
  return {
    loading,
    isAutoApprover,
  }
}

export default useIsAccessInAutoApprovalGroup
